import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { AnalyticsService } from '../../core/services/analytics.service';
import { BooksService } from '../../core/services/data/books.service';
import { AlertsService } from '../../core/services/alerts.service';
import { PurchaseProcessService } from '../../core/services/data/purchase-process.service';

@Component({
	selector: 'app-notification-cards',
	templateUrl: './notification-cards.component.html',
	styleUrls: ['./notification-cards.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NotificationCardsComponent {
	public notificationType = [
		'late_link',
		'feature_live',
		'failed_feature',
		'cart_abandon',
		'survey_follow_up',
		'prep_for_feature',
		'keep_in_touch',
	];

	public moment = moment;

	@Input() author;

	@Input() alerts = {};

	@Input() mobile = false;

	@Output() sendMailEvent = new EventEmitter();

	constructor(
		private router: Router,
		private as: AlertsService,
		private ans: AnalyticsService,
		private bs: BooksService,
		private purchaseProcessService: PurchaseProcessService,
	) {}

	dismiss(alertType) {
		this.as.dismiss(alertType, this.author._id);
	}

	promote(ASIN) {
		this.dismiss('keep_in_touch');
		this.ans.referrer = 'Books - List Specific';
		this.purchaseProcessService.setDetails({
			feature: {
				ASIN,
			},
			book: {
				ASIN,
				amazonLink: `https://www.amazon.com/dp/${ASIN}`,
			},
		}, 'notification-card');
		this.router.navigate([`/author-dashboard/${this.author.authorLink}/features`]).then();
	}

	sendMail(type) {
		this.sendMailEvent.emit(type);
	}
}
